import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import PageBanner from '../components/PageBanner';
import SectionRenderer from '../components/page-builder/SectionRenderer';
import { useSettings } from '../context/SettingsContext';
import { getPage } from '../lib/pageDefaults';

/** Renders custom (blank template) CMS pages from Page Builder */
export default function CmsPage() {
  const { pathname } = useLocation();
  const { settings } = useSettings();
  const page = getPage(settings?.page_builder, pathname);

  if (!page || page.isSystem || page.template !== 'blank') {
    return <Navigate to="/" replace />;
  }
  if (page.status === 'draft') {
    return (
      <div className="pt-32 pb-20 text-center text-gray-500">
        Halaman ini masih draft.
      </div>
    );
  }

  return (
    <>
      <PageBanner
        title={page.title || page.name}
        subtitle={page.subtitle || ''}
        breadcrumb={[page.name]}
      />
      <SectionRenderer sections={page.sections || []} />
    </>
  );
}
